import React from 'react';
import '../assets/css/theme.css';

function LoadingSpinner() {
  return (
    <div className="ffh-loader" role="status" aria-label="Loading">
      <span />
      <span />
      <span />
    </div>
  );
}

export default LoadingSpinner;